module.exports = __webpack_public_path__ + "img/gold-egg.b3bae467.gif";